import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as fromMeasures from '@store/selectors/measures/measures.selectors';
import { firstValueFrom } from 'rxjs';
import { IDropdown } from '@models/dropdown.model';

@Component({
  selector: 'app-measure-types',
  imports: [],
  templateUrl: './measure-types.component.html',
  styleUrl: './measure-types.component.css'
})
export class MeasureTypesComponent implements ICellRendererAngularComp{

  private readonly store = inject(Store);
  typesList$ = this.store.select<IDropdown[]>(fromMeasures.selectMeasureTypeList);
  displayName: string = '';

   agInit(params: ICellRendererParams<any, any, any>): void {
    this.getMeasureType(Number(params.value)).then(displayName => {
      this.displayName = displayName;
    });
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.getMeasureType(Number(params.value)).then(displayName => {
      this.displayName = displayName;
    });
    return true;
  }

  async getMeasureType(id:number): Promise<string> {
    const types = await firstValueFrom(this.typesList$);
    return types.find(t => t.id === id)?.name || 'Unknown';
  }
}